import React, { useContext, useState } from 'react';
import {
	Card,
	CardRow,
	SummaryValue,
	StyledLink,
	CloseModalSpan,
} from './style';
import {
	BriefingContext,
	ObjectivesContantsSmallNames,
} from '../../../../containers/campanhas/Briefing';
import { StyledH2 } from '../../../../containers/campanhas/Briefing/style';
import CheckboxInput from '../../CheckboxInput';
import Modal from '../../Modal';
import Idea from '../../../../img/idea.png';
import Button from '../../Button';
import { BriefingTitleRow } from '../index';

const BriefingStep7 = () => {
	const {
		campaign,
		gtm,
	} = useContext(BriefingContext);

	const [isModalOpen, setModalOpen] = useState(false);

	const closeModal = () => {
		gtm.sendGtmMetrics('termRefuse');
		setModalOpen(false);
	};

	const closeModalAndAccept = () => {
		gtm.sendGtmMetrics('termAccept');
		campaign.setUserAccepted(true);
		setModalOpen(false);
	};

	const acceptTerm = () => {
		if (!campaign.userAccepted) {
			gtm.sendGtmMetrics('termAccept');
		}
		campaign.setUserAccepted(!campaign.userAccepted);
	};

	const formatRanges = () => {
        let outputText = '';
		campaign.campaignRange.forEach((range, index) => {
			outputText += index > 0
				? ` | ${range.city} - ${range.province}`
				: `${range.city} - ${range.province}`;
		});
		return outputText;
	};

	const LabelWithModal = () => (
		<>
			{'Li e estou de acordo com o '}
			<StyledLink onClick={() => setModalOpen(true)}>Termo de adesão</StyledLink>
		</>
	);

	const AdhesionModal = () => (
		<Modal
			isOpen={isModalOpen}
			openAction={() => setModalOpen(!isModalOpen)}
			borderRadius="8px"
			contentWidth="80%"
		>
			<CloseModalSpan onClick={closeModal}>X</CloseModalSpan>
			<div
				style={{
					padding: '60px 110px',
				}}
			>
				<img src={Idea} alt="" />
				<h1>Termo de adesão</h1>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eros dolor,
					tincidunt at egestas ac, porttitor sed mauris. Mauris nec enim viverra, dictum elit non,
					blandit magna. Curabitur placerat molestie orci, a aliquet enim laoreet ut.
					Nam varius lobortis elit, eu cursus justo interdum eget. Donec consectetur lectus quam.
					In dignissim erat ut orci convallis, eget consectetur nibh efficitur.
					Nunc eget justo nisi.
					In leo ligula, efficitur in ipsum auctor, maximus pulvinar turpis.
					Nunc tristique tellus sit amet turpis molestie, efficitur viverra velit tristique.
					Aliquam malesuada dui non quam tempus malesuada.
					Fusce in nibh malesuada metus aliquam suscipit.
					Fusce sit amet faucibus mi.
					Aenean aliquam placerat ante, eu placerat augue malesuada sed.
					Sed lorem enim, ornare a ipsum vitae, sollicitudin ullamcorper lorem.
					Donec dignissim nisl est, sit amet ultrices diam sodales vitae.
				</p>
				<p>
					Nullam enim nisl, vehicula sit amet tincidunt nec, pellentesque sed nulla.
					Phasellus mi enim, placerat eu ullamcorper in, consequat vitae arcu.
					Cras pharetra pretium metus non blandit.
					Suspendisse venenatis in nibh vitae dictum.
					Curabitur a eros orci.
					Praesent sed facilisis tellus.
					Proin et mollis lorem.
				</p>
				<p>
					Nullam arcu nunc, condimentum at rutrum luctus, tincidunt a eros.
					Pellentesque egestas pretium dui, sit amet posuere ligula luctus ac.
					Quisque ultrices ipsum et mollis tristique.
					Donec bibendum egestas elit.
					Cras feugiat turpis quis lacus pellentesque, a blandit arcu dignissim.
					Sed faucibus molestie eros, ut pharetra nisi dictum vehicula.
					Quisque at consequat diam. Donec in fermentum lorem.
				</p>
				<div className="row mt-5" style={{ justifyContent: 'center' }}>
					<div className="col-4">
						<Button onClick={closeModalAndAccept}>Aceito!</Button>
					</div>
				</div>
			</div>
		</Modal>
	);

    return (
	<>
		<AdhesionModal />
		<BriefingTitleRow>
			Revise as configuraçoes da sua campanha, aceite o termo de adesão e contrate.
		</BriefingTitleRow>
		<div className="row">
			<div className="col-12 col-md-7">
				<Card>
					<StyledH2>Resumo da campanha:</StyledH2>
					<CardRow>
						<span>Canal:</span>
						<SummaryValue>{campaign.channel}</SummaryValue>
					</CardRow>
					<CardRow>
						<span>Objetivo:</span>
						<SummaryValue>{ObjectivesContantsSmallNames[campaign.campaignObjective]}</SummaryValue>
					</CardRow>
					<CardRow>
						<span>Logo:</span>
						<SummaryValue>{campaign.nameLogo}</SummaryValue>
					</CardRow>
					<CardRow>
						<span>Praças:</span>
						<SummaryValue>{formatRanges()}</SummaryValue>
					</CardRow>
				</Card>
			</div>
			<div className="col-12 col-md-5">
				<Card className="mb-4">
					<StyledH2>Valor da contratação:</StyledH2>
					<CardRow>
						<span>Recorrência:</span>
						<SummaryValue className="red">Mensal</SummaryValue>
					</CardRow>
					<CardRow>
						<span>Valor:</span>
						<SummaryValue className="red">{campaign.campaignInvestment.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}/mês</SummaryValue>
					</CardRow>
				</Card>
				<>
					<CheckboxInput
						label={LabelWithModal()}
						isChecked={campaign.userAccepted}
						setChecked={acceptTerm}
					/>
				</>
			</div>
		</div>
	</>
    );
};

export default BriefingStep7;
